import React, { useState } from 'react';
import DatePicker from './DatePicker';
import './SearchBar.css';

function SearchBar({ onSearch, isCompact = false, onOpenFilters, initialSearch }) {
  const [search, setSearch] = useState(initialSearch || {
    location: '',
    checkIn: '',
    checkOut: '',
    guests: ''
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    const updatedSearch = { ...search, [name]: value };
    setSearch(updatedSearch);
    
    // Auto-trigger search when all fields are filled
    if (updatedSearch.location && updatedSearch.checkIn && updatedSearch.checkOut && updatedSearch.guests && onSearch) {
      setTimeout(() => onSearch(updatedSearch), 300);
    }
  };

  const handleSearch = (e) => {
    e.preventDefault();
    if (onSearch && search.location && search.checkIn && search.checkOut && search.guests) {
      onSearch(search);
    }
  };

  if (isCompact) {
    const formatDate = (dateStr) => {
      if (!dateStr) return '';
      const date = new Date(dateStr);
      return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
    };

    return (
      <div className="search-bar compact">
        <div className="compact-search-info">
          <span className="info-item">
            {search.location ? `📍 ${search.location}` : 'Where'}
          </span>
          <span className="separator">|</span>
          <span className="info-item">
            {search.checkIn && search.checkOut 
              ? `${formatDate(search.checkIn)} - ${formatDate(search.checkOut)}`
              : 'When'
            }
          </span>
          <span className="separator">|</span>
          <span className="info-item">
            {search.guests ? `${search.guests} guests` : 'Who'}
          </span>
        </div>

        <button type="button" className="search-btn compact-search">
          🔍
        </button>

        {onOpenFilters && (
          <button 
            type="button" 
            className="filters-btn" 
            onClick={onOpenFilters}
          >
            ⚙️ Filters
          </button>
        )}
      </div>
    );
  }

  return (
    <form className="search-bar" onSubmit={handleSearch}>
      <div className="search-input-group">
        <label>Where</label>
        <input
          type="text"
          name="location"
          placeholder="Search destinations"
          value={search.location}
          onChange={handleChange}
        />
      </div>

      <DatePicker 
        onDateChange={(dates) => setSearch({ ...search, checkIn: dates.checkIn, checkOut: dates.checkOut })}
        checkIn={search.checkIn}
        checkOut={search.checkOut}
      />

      <div className="search-input-group">
        <label>Who</label>
        <input
          type="number"
          name="guests"
          placeholder="Add guests"
          value={search.guests}
          onChange={handleChange}
          min="1"
        />
      </div>

      <button type="submit" className="search-btn">
        🔍
      </button>
    </form>
  );
}

export default SearchBar;
